<template>
  <div class="container mx-auto">
    <div
      v-if="init"
      class=" border-b-2 "
    >
      <div class="flex flex-row py-4">
        <div class="flex flex-col">
          <div>
            <select
              id="grid-state"
              :value="selectedYouth"
              class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey"
              @change="youthChanged"
            >
              <option
                v-for="item in youthes"
                :key="item.key"
                :value="item.key"
              >
                {{ item.key }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <input
            v-model="searchTerm"
            type="text"
            placeholder="Suche"
            class="flex-grow bg-gray-200 appearance-none border-2 border-green-200 rounded w-64 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-500"
            @keyup.enter="searchChanged()"
          >
          <i
            class="fas fa-search cursor-pointer ml-4 text-green-500"
            @click="search"
          />
        </div>
      </div>
      <div
        class="cursor-pointer p-4  justify-between"
        @click.prevent="expanded = !expanded"
      >
        <strong><i class="fas fa-filter" /> Filter <i
          class="text-xs font-thin"
        > {{ tagMessage }}</i></strong>
      </div>
      <div
        v-show="expanded"
        class="p-4 ml-8 mr-8"
      >
        <div class="mx-auto mb-10 flex flex-wrap">
          <div>
            <p class=" font-semibold">
              Kategorie
            </p>
            <select
              id="forms"
              v-model="selectedForm"
              class="block bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey"
              @change="onFormSelected($event)"
            >
              <option
                v-for="form in aviableForms"
                :key="form.name"
              >
                {{ form.name }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <p class=" font-semibold">
              Tags <i
                class="text-xs font-thin cursor-pointer"
                @click="clearFilter"
              >entfernen</i>
            </p>
            <div class="flex flex-wrap text-sm px-6 py-4 mb-2 align-bottom font-semibold">
              <span
                v-for="tag in aviableTags"
                :key="tag.name"
                data-balloon="Filter hinzufügen"
                data-balloon-pos="up"
                class="p-tag mr-1 mb-1"
                :class="{'active-tag':isSelected(tag.name)}"
                @click="toggleTag(tag.name)"
              >#{{ tag.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isBusy"
      class="flex justify-center mb-2"
    >
      <ul class="flex list-reset border border-grey-light rounded w-auto bg-white">
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
            @click="goToPage(1)"
          >Erste</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
            @click="prevPage"
          > Zurück</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
          >{{ page }}</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue px-3 py-2 cursor-pointer"
            @click="nextPage"
          >Weiter
            >></a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue px-3 py-2 cursor-pointer"
            @click="goToPage(totalPages)"
          >Letzte ({{ totalPages }})</a>
        </li>
      </ul>
    </div>

    <div class="flex justify-center mb-4">
      <div
        v-if="isBusy"
        class="spinner"
      >
        <div class="bounce1" />
        <div class="bounce2" />
        <div class="bounce3" />
      </div>
      <div
        v-if="!isBusy &&( !exercises ||exercises.length<=0)"
        class="bg-teal-lightest border-t-4 border-teal rounded-b text-teal-darkest px-4 py-3 shadow-md"
        role="alert"
      >
        <div class="flex">
          <div class="py-1">
            <svg
              class="fill-current h-6 w-6 text-teal mr-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            Auf die gewählten Filter treffen keine Übungen zu. <i
              class="cursor-pointer"
              @click="clearFilter"
            >Filter
              zurücksetzen</i>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isBusy"
      class="flex flex-wrap justify-center ">
      <sc-exercise-small
        v-for="item in exercises"
        :key="item.shortKey"
        :title="item.titel"
        :image="item.previewAsset"
        :short-key="item.shortKey"
        :tags="item.tags"
        :intensity="item.intensity"
        :prefered-preview-media="item.preferedPreviewMedia "
        :show-add-button="true"
        :show-open-button="true"
        :difficulty="item.difficulty"
        :mediaConsent="functionalAllowed"
        @AddClicked="onSelected(item)"
      />
    </div>

    <div
      v-if="!isBusy"
      class="flex justify-center mb-2"
    >
      <ul class="flex list-reset border border-grey-light rounded w-auto bg-white">
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
            @click="goToPage(1)"
          >Erste</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
            @click="prevPage"
          > Zurück</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue border-r border-grey-light px-3 py-2 cursor-pointer"
          >{{ page }}</a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue px-3 py-2 cursor-pointer"
            @click="nextPage"
          >Weiter>></a>
        </li>
        <li>
          <a
            class="block hover:text-white hover:bg-blue text-blue px-3 py-2 cursor-pointer"
            @click="goToPage(totalPages)"
          >Letzte ({{ totalPages }})</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import apiService from './api/apiService'

export default {
    name: 'SearchContainer',
    props: {
        selectedYouth: {
            type: String,
            required: false
        },
        autoRedirect: {
            type: Boolean,
            required: false,
            default: false
        },
        addTagToQuery: {
            type: Boolean,
            required: false,
            default: false
        },
        showAddButton: {
            type: Boolean,
            required: false,
            default: false
        },
        showOpenButton: {
            type: Boolean,
            required: false,
            default: false
        }

    },

    data () {
        return {
            init: false,
            isBusy: true,
            selectedForm: '',
            expanded: false,
            youthes: [],
            aviableTags: [],
            aviableForms: [],
            checkedNames: [],
            exercises: [],
            selectedTags: [],
            totalCount: 0,
            searchTerm: '',
            page: 1,
            pageSize: 8,
            totalPages: 0,
            functionalAllowed: false
        }
    },
    computed: {

        tagMessage: function () {
            var filterString = ''

            if (this.selectedYouth && this.selectedYouth.length > 0) {
                filterString = 'Jugend: ' + this.selectedYouth + ' - '
            }

            if (this.selectedForm && this.selectedForm.length > 0) {
                filterString += 'Kategorie: ' + this.selectedForm + ' '
            }
            if (this.selectedTags && this.selectedTags.length > 0) {
                filterString += ' Tags: '
                filterString += this.selectedTags.join(',')
            }

            filterString = '(' + filterString + ')'
            return filterString
        }
    },
    watch: {
        selectedYouth () {
            this.search()
        }
    },
    async mounted () {
        this.isBusy = true

        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional

        await this.getTags()
        await this.getForms()
        var response = await apiService.getYouths()

        this.youthes = response.data

        var page = this.$route.query.page

        if (page) {
            this.page = page
        }

        var tags = this.$route.query.tags
        if (tags) {
            if (tags.indexOf(',') > -1) {
                tags = tags.split(',')
                this.selectedTags = tags
            } else {
                this.selectedTags.push(tags)
            }
        }

        await this.search()

        this.init = true
    },
    methods: {

        async loadImgs () {
        // TODO Split iamge id and image value in 2 properties !

            var data = this.exercises
            for (var i = 0, _len = this.exercises.length; i < _len; i++) {
                var item = data[i]
                item.previewAsset = ''
                item.previewAsset = null
                if (item.assetIds && item.assetIds.length > 0) {
                    var id = item.previewImage

                    if (!id || id.length < 5) {
                        id = item.assetIds[0]
                    }

                    item.previewAsset = id
                }
            }

            this.$forceUpdate()
        },
        textDifficulty (item) {
            if (item.difficulty === 1) {
                return 'Anfänger'
            } else if (item.difficulty === 2) {
                return 'Leicht'
            } else if (item.difficulty === 3) {
                return 'Mittel'
            } else if (item.difficulty === 4) {
                return 'Schwer'
            }
        },
        colorDifficulty (item) {
            if (item.difficulty < 3) {
                return 'text-green-600'
            } else if (item.difficulty === 3) {
                return 'text-yellow-600'
            } else if (item.difficulty === 4) {
                return 'text-red-600'
            }
        },
        colorIntensity (item) {
            if (item.intensity < 3) {
                return 'text-green-600'
            } else if (item.intensity === 3) {
                return 'text-yellow-600'
            } else if (item.intensity === 4) {
                return 'text-orange-600'
            } else if (item.intensity >= 5) {
                return 'text-red-600'
            }
        },
        emptyDifficultSquares (item) {
            return 4 - item.difficulty
        },
        emptyIntensitySquares (item) {
            return 5 - item.intensity
        },
        async goToPage (page) {
            this.page = page
            await this.search()
        },
        async nextPage () {
            if (this.page < this.totalPages) {
                this.page++
                await this.search()
            }
        },
        async prevPage () {
            if (this.page > 1) {
                this.page--
                await this.search()
            }
        },
        youthChanged (event) {
            this.$emit('selectedYouth', event.target.value)
        },
        onSelected (item) {
            this.$emit('exerciseSelected', item)
        },
        isSelected (button) {
            if (button) {
                return this.selectedTags.includes(button)
            } else {
                return false
            }
        },

        onFormSelected: function (val) {
            this.search()
        },
        async clearFilter () {
            this.selectedTags = []

            await this.search()
        },

        async toggleTag (tag) {
            if (tag) {
                if (this.selectedTags.includes(tag)) {
                    var index = this.selectedTags.indexOf(tag)
                    if (index > -1) {
                        this.selectedTags.splice(index, 1)
                    }
                } else {
                    this.selectedTags.push(tag)
                }

                if (this.addTagToQuery) {
                    if (history.pushState) {
                        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?tags=' + this.selectedTags.join(',')
                        window.history.pushState({ path: newurl }, '', newurl)
                    }
                }
                this.page = 1
                await this.search()
            }
        },

        async getForms () {
            const response = await apiService.getForms()
            this.aviableForms = response.data
        },
        async getTags () {
            const response = await apiService.getTags()
            this.aviableTags = response.data
        },

        async searchChanged () {
            this.page = 1
            await this.search()
        },

        async search () {
            this.isBusy = true

            var youth = this.selectedYouth
            if (!youth) {
                youth = 'f'
            }
            const response = await apiService.getExercises(youth, this.selectedForm, this.searchTerm, this.selectedTags, this.page, this.pageSize)
            const { data } = response

            for (var i = 0, _len = data.items.length; i < _len; i++) {
                var item = data.items[i]
                item.previewAsset = ''
            }
            this.totalCount = data.total
            this.exercises = data.items

            this.totalPages = data.totalPages
            this.isBusy = false

            this.loadImgs()
        }

    }
}
</script>

<style scoped>
  .active-tag {
    color: red;
  }

</style>
